module.exports = __webpack_public_path__ + "static/img/化學師資介紹.93de3f3e.png";